import React from "react";
import LiveKitVideo from "./LiveKitVideo";
import Icon from "./Icon";

/* local copy for now (we'll move to utils later without behavior change) */
const AVATAR_GRADIENTS = [
  ["#4ADE80", "#16A34A"],
  ["#38BDF8", "#0284C7"],
  ["#FCD34D", "#D97706"],
  ["#C084FC", "#7C3AED"],
  ["#FB7185", "#BE123C"],
  ["#FB923C", "#C2410C"],
  ["#34D399", "#059669"],
  ["#A78BFA", "#5B21B6"],
];

const getAvatarColors = (name = "") => {
  if (!name || typeof name !== "string") return AVATAR_GRADIENTS[0];
  return AVATAR_GRADIENTS[name.charCodeAt(0) % AVATAR_GRADIENTS.length];
};

function PresenterCard({ p, onPress }) {
  const {
    name,
    image,
    role,
    isMuted,
    isSpeaking,
    isLocal,
    hasVideo,
    trackRef,
  } = p;

  const roleLabel = role === "host" ? "Host" : "Speaker";
  const roleColor = role === "host" ? "var(--jt-gold)" : "var(--jt-purple)";
  const [c1, c2] = getAvatarColors(name);

  return (
    <button
      className={`jt-presenterCard ${isSpeaking ? "speaking" : ""}`}
      onClick={hasVideo ? onPress : undefined}
      type="button"
    >
      <div className="jt-presenterMedia">
        {hasVideo && trackRef ? (
          <LiveKitVideo
            trackRef={trackRef}
            muted={isLocal}
            mirror={isLocal}
            objectFit="cover"
          />
        ) : (
          <div
            className="jt-presenterAvatar"
            style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}
          >
            {image ? (
              <img src={image} alt="" />
            ) : (
              <span>{(name?.[0] || "?").toUpperCase()}</span>
            )}
          </div>
        )}
        <div className="jt-presenterShade" />
      </div>

      <div className="jt-presenterTopBadges">
        <div
          className="jt-roleBadge"
          style={{ borderColor: roleColor, color: roleColor }}
        >
          {roleLabel}
        </div>

        {isSpeaking && (
          <div className="jt-speakingPips" aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
          </div>
        )}
      </div>

      <div className="jt-presenterBottom">
        <div className="jt-presenterName" title={name}>
          {isLocal ? "You" : name}
        </div>

        <div className={`jt-miniMic ${isMuted ? "off" : "on"}`}>
          {isMuted ? <Icon name="micOff" /> : <Icon name="mic" />}
        </div>
      </div>
    </button>
  );
}

export default function PresentersRow({ presenters, onPress }) {
  if (!presenters?.length) return null;

  const slice = presenters.slice(0, 2);

  return (
    <div className="jt-presentersRow">
      <div className="jt-presentersInner">
        {slice.map((p) => (
          <PresenterCard key={p.id} p={p} onPress={() => onPress(p)} />
        ))}

        {presenters.length > 2 && (
          <div className="jt-moreBadge">+{presenters.length - 2}</div>
        )}
      </div>
    </div>
  );
}
